<template>
    <div class="w-full h-full flex flex-col">
        <h1 class="text-brand text-lg font-extrabold mb-2 border-gray-200 border-b h-8 overflow-hidden">
            <span class="ml-4 whitespace-nowrap"><i class="far fa-check mr-4"></i>Tasks</span>
        </h1>
        <main class="overflow-hidden flex-1" v-if="this.tasks">
            <template v-if="this.tasks.length">
                <ui-crud-card v-for="item in this.tasks" :key="item.id"
                              :title="item.name"
                              :subtitle="(item.has_package ? item.package.common : '—')"
                              :metadata="item.due"
                              @click="select(item)"
                ></ui-crud-card>
            </template>
            <div class="place-content-center w-full" v-else>
                <div class="flex flex-col text-gray-500">
                    <div class="w-full text-center font-bold text-md"><span><i
                        class="text-lg text-green-600 far fa-check mr-4"></i></span>No outstanding tasks
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>

import {Task} from "@models";
import _ from "lodash";

export default {
    components: {},
    props: {
        dashboardData: Object,
        dashboardProps: Object,
    },
    data() {
        return {
            tasks: null
        }
    },
    computed: {},
    methods: {
        select(item) {
            if (item._links.frontend.package_view) {
                window.location.href = item._links.frontend.package_view
            }
        },
    },
    async mounted() {
        let tasks = await Task.all('', this.dashboardProps.legacyPackage.reference)
        tasks = tasks.filter((item) => !item.complete)
        this.tasks = _.orderBy(tasks, function (task) {
            return (task.due ? task.due : '')
        }, 'ASC')
    }
}

</script>